<template>
  <v-card>
    <DataSetContextMenuRecycle ref="datasetMenu" @reload="refresh()" />
    <Subheader dense title="Recycle Bin" no-search>
      <!-- <PrimaryBtn icon="add" v-if="isTenantAdmin" color="success" @click="addFile()">
        {{ $t('Button.Add_a_new_File') }}
      </PrimaryBtn> -->
      <SecondaryBtn light color="info" icon="refresh" @click="refresh()">
        {{ $t('Refresh') }}
      </SecondaryBtn>
    </Subheader>

    <v-data-table class="files-table" :class="{ 'five-items': tempModel.rowsPerPage === 5, 'ten-items': tempModel.rowsPerPage === 10, 'twenty-five-items': tempModel.rowsPerPage === 25 }" :headers="dataHeaders" :items="fileItems" :pagination.sync="tempModel" :total-items="totalItems" :loading="searchLoading">
      <template slot="items" slot-scope="props">
        <td class="name-td maximize no-wrap">
          <span>
            <v-icon small>save_alt</v-icon>
            {{ props.item.Name }}
          </span>
        </td>
        <td class="no-wrap">
          {{ props.item.FileType}}
        </td>
        <td class="no-wrap">
          {{ formatDateTime(props.item.DeleteDateTime, { format: prettyDateTimeFormat, excludeUtcText: true }) }}
        </td>
        <td class="no-wrap">
          {{ formatDateTime(props.item.DateCreated, { format: prettyDateTimeFormat, excludeUtcText: true }) }}
        </td>
        <!--<td>{{ props.item.ValidationStatus }}</td>-->
        <td style="width: 140px;" class="text-xs-center no-wrap">
          <v-btn :loading="props.item.loading" class="box-shadow" icon @click="$refs.datasetMenu.show(props.item)">
            <v-icon color="info">more_vert</v-icon>
          </v-btn>
        </td>

      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import Subheader from '@/components/generic/Subheader'
  import MomentUtil from '@/components/mixins/MomentUtil'
  import DownloadUtil from '@/components/mixins/DownloadUtil'
  import DataSetContextMenuRecycle from '@/components/DataSets/DataSetContextMenuRecycle'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const authenticate = createNamespacedHelpers('authenticate')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')

  import {
    prettyDateTimeFormat,
  } from '@/components/mixins/MomentUtil'


  export default {
    name: 'data-set-table',
    model: {
      prop: 'pagination',
      event: 'change',
    },
    components: {
      Subheader,
      DataSetContextMenuRecycle,
    },
    mixins: [DownloadUtil, MomentUtil],
    props: {
      pagination: {
        type: Object,
        default: () => {
          return {}
        },
      },
      files: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
      totalItems: {
        type: Number,
        default: 0,
      },
      searchLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        tempModel: {
          descending: true,
          sortBy: 'DeleteDateTime',
        },
        prettyDateTimeFormat,
        dataHeaders: [
          //{ text: 'Id', value: 'ID', align: 'left' },
          {
            text: 'Name',
            value: 'Name',
            align: 'left',
          },
          {
            text: 'File Type',
            value: 'FileType',
            align: 'left',
          },
          {
            text: 'Date Deleted (UTC)',
            value: 'DeleteDateTime',
            align: 'left',
          },
          {
            text: 'Date Created (UTC)',
            value: 'DateCreated',
            align: 'left',
          },
          //{ text: 'Status', value: 'ValidationStatus', sortable: false },
          {
            text: 'Actions',
            align: 'center',
            sortable: false,
          },
        ],
        search: '',
        fileItems: [],
        isloadingFinish: false,
        unWatch: function() {},
      }
    },
    computed: {
      ...authenticate.mapGetters(['isTenantAdmin']),
      ...rawdatarepository.mapGetters(['metadataSchemaById']),
      schema() {
        let schemaList = this.metadataSchemaById(this.schemaId)
        return schemaList.length > 0 ?
          JSON.parse(JSON.stringify(schemaList[0])) :
          null
      },
    },
    watch: {
      files(value) {
        this.fileItems = value.map(file => ({
          ...file,
          FileType: this.getFileType(file.SchemaId),
          downloading: false,
        }))
      },
      pagination(v) {
        if(this.isloadingFinish) {
          this.tempModel = v
        } else {
          if(v.page == 1) {
            this.isloadingFinish = true
          }
          this.tempModel = v
        }
      },
      loading(v) {
        if(!v) {
          var that = this
          this.unWatch = this.$watch('tempModel', (newVal, oldVal) => {
            let temp
            if(newVal.rowsPerPage == oldVal.rowsPerPage) {
              temp = newVal
              temp.offset = (newVal.page - 1) * newVal.rowsPerPage
              that.$emit('change', temp)
            } else {
              that.changeRowsPerPage(newVal, oldVal)
            }
          })
        }
      },
    },
    methods: {
      refresh() {
        this.unWatch()
        this.$parent.fetchFiles({
          forced: true,
        })
      },
      changeRowsPerPage(newVal, oldVal) {
        this.unWatch()
        var temp = oldVal
        let num = oldVal.rowsPerPage * (oldVal.page - 1) + 1
        let newPage = Math.floor(num / newVal.rowsPerPage) + 1

        temp.rowsPerPage =  newVal.rowsPerPage
        temp.page = newPage
        temp.offset = (newPage - 1) * newVal.rowsPerPage
        this.tempModel = temp
        this.$emit('change', temp)
        this.$parent.fetchFiles({
          forced: true,
        })
      },
      getFileType(schemaId) {
        let schemaList = this.metadataSchemaById(schemaId)
        let schema = schemaList.length > 0 ? JSON.parse(JSON.stringify(schemaList[0])) : null
        return schema != null ? schema.Name : 'Unknown'
      },
      addFile() {
        this.$emit('addFile')
      },
      viewFile(item){        
        this.$router.push(`/datasets/${item.Id}`)
      },
      downloadFile(item) {
        let that = this
        item.downloading = true
        that.$store.dispatch('app/setSnackbar', {
          text: 'Please wait while we prepare your download...',
          color: 'success',
          timeout: 0,
        })
        let options = {
          successful: () => {
            item.downloading = false
          },
          failedCb: (error) => {
            item.downloading = false
            that.$store.dispatch('app/setSnackbar', {
              text: error,
              color: 'error',
              icon: 'error',
            })
          },
        }

        that.download(
          `api/RawDataRepository/file/${ item.Id }/download`,
          item.Name,
          options
        )
      },
    },
  }
</script>

<style scoped>
  td {
    max-width: 300px;
    overflow-wrap: break-word;
  }

  .no-wrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .maximize {
    width: 99%;
  }
</style>

<style>
  .files-table.five-items>.v-table__overflow {
    min-height: 297px;
    background: #fafafa;
  }

  .files-table.ten-items>.v-table__overflow {
    min-height: 537px;
    background: #fafafa;
  }

  .files-table.twenty-five-items>.v-table__overflow {
    min-height: 1257px;
    background: #fafafa;
  }
</style>
